module.exports = __webpack_public_path__ + "static/media/birds-eye-login-logo.8887719f.png";